/**
 * ProgressIndicator Component
 * Displays progress through the form as a visual bar and text
 */

interface ProgressIndicatorProps {
  currentStep: number
  totalSteps: number
  className?: string
}

const ProgressIndicator = ({ currentStep, totalSteps, className = '' }: ProgressIndicatorProps) => {
  const progressPercentage = (currentStep / totalSteps) * 100

  return (
    <div className={`w-full ${className}`}>
      {/* Progress text */}
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-gray-600">
          Question {currentStep} of {totalSteps}
        </span>
        <span className="text-sm font-medium text-primary-green">
          {Math.round(progressPercentage)}% complete
        </span>
      </div>

      {/* Progress bar */}
      <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
        <div
          className="bg-primary-green h-full rounded-full transition-all duration-500 ease-out"
          style={{ width: `${progressPercentage}%` }}
          role="progressbar"
          aria-valuenow={progressPercentage}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`Form progress: ${Math.round(progressPercentage)}% complete`}
        />
      </div>
    </div>
  )
}

export default ProgressIndicator
